import { BrowserRouter, Route, Routes } from "react-router-dom";
import PublicSite from "@/components/PublicSite";
import AdminPanel from "@/components/AdminPanel";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="*" element={<PublicSite />} />
      </Routes>
    </BrowserRouter>
  );
}
